import React from 'react'
import { jsPDF } from 'jspdf'
import autoTable from 'jspdf-autotable'
import * as XLSX from 'xlsx'
import robotoRegularBase64 from '../../assets/fonts/Roboto-Regular-base64'
import styles from './DownloadAsDocumentButton.module.css'
import downloadIcon from '../../assets/icons/downloadIcon.png'

interface OrderData {
  name: string
  price: number
  quantity: number
  productId: number
}

interface DownloadAsDocumentButtonProps {
  data: OrderData[]
  smet: number[]
}

const DownloadAsDocumentButton: React.FC<DownloadAsDocumentButtonProps> = ({ data, smet }) => {
  const downloadPDF = () => {
    const doc = new jsPDF()

    doc.addFileToVFS('Roboto-Regular.ttf', robotoRegularBase64)
    doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal')
    doc.setFont('Roboto', 'normal')

    doc.setFontSize(18)
    doc.text('Смета заказа', 14, 20)

    const totalItemsSum = data.reduce((sum, item) => sum + item.price * item.quantity, 0)

    const tableBody = data.map((item) => [
      item.name,
      item.price.toString() + ' руб.',
      item.quantity.toString() + ' шт.',
      (item.price * item.quantity).toString() + ' руб.',
    ])

    autoTable(doc, {
      head: [['Имя', 'Цена', 'Количество', 'Итого']],
      body: tableBody,
      startY: 30,
      theme: 'grid',
      styles: {
        font: 'Roboto',
        fontSize: 12,
      },
      headStyles: {
        font: 'Roboto',
        fillColor: [209, 209, 209],
        textColor: 0,
        fontSize: 12,
        fontStyle: 'normal',
      },
      willDrawCell: (data) => {
        if (data.section === 'head') {
          doc.setFont('Roboto', 'normal')
        }
      },
    })

    // @ts-ignore
    let finalY = (doc as any).lastAutoTable?.finalY || 80

    if (finalY + 50 > 280) {
      doc.addPage()
      finalY = 20
    }

    doc.setFontSize(12)
    doc.text('Скидка: ' + smet[0] + ' руб.', 14, finalY + 10)
    doc.text('Сервисный сбор: ' + smet[1] + ' руб.', 14, finalY + 20)
    doc.text('Пробковый сбор: ' + smet[2] + ' руб.', 14, finalY + 30)
    doc.setFontSize(14)
    doc.text('Итоговая сумма: ' + smet[3] + ' руб.', 14, finalY + 40)

    doc.save('order_data.pdf')
  }

  const downloadExcel = () => {
    const dataForExcel = [
      ...data.map((item) => ({
        Имя: item.name,
        Цена: item.price + ' руб.',
        Количество: item.quantity,
        Итого: item.price * item.quantity + ' руб.',
      })),
      { Имя: '', Цена: '', Количество: '', Итого: '' },
      { Имя: '', Цена: '', Количество: 'Скидка:', Итого: smet[0] + ' руб' },
      { Имя: '', Цена: '', Количество: 'Сервисный сбор:', Итого: smet[1] + ' руб' },
      { Имя: '', Цена: '', Количество: 'Пробковый сбор:', Итого: smet[2] + ' руб' },
      { Имя: '', Цена: '', Количество: 'Итоговая сумма:', Итого: smet[3] + ' руб' },
    ]

    const worksheet = XLSX.utils.json_to_sheet(dataForExcel)

    worksheet['!cols'] = [{ wch: 30 }, { wch: 15 }, { wch: 15 }, { wch: 15 }]

    const range = XLSX.utils.decode_range(worksheet['!ref'] || '')
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellRef = XLSX.utils.encode_cell({ r: R, c: C })
        if (!worksheet[cellRef]) continue

        if (R >= data.length + 1) {
          worksheet[cellRef].s = {
            font: { bold: true },
            border: {
              top: { style: 'thin', color: { rgb: '000000' } },
              left: { style: 'thin', color: { rgb: '000000' } },
              bottom: { style: 'thin', color: { rgb: '000000' } },
              right: { style: 'thin', color: { rgb: '000000' } },
            },
          }
        }
      }
    }

    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Orders')

    XLSX.writeFile(workbook, 'order_data.xlsx')
  }

  return (
    <div className={styles.buttonBlock}>
      <h2>Загрузить смету</h2>
      <div className={styles.buttonGroup}>
        <button onClick={() => downloadPDF()}>
          <img src={downloadIcon} alt='downloadIcon' />
          Скачать PDF
        </button>

        <button onClick={() => downloadExcel()}>
          <img src={downloadIcon} alt='downloadIcon' />
          Скачать Excel
        </button>
      </div>
    </div>
  )
}

export default DownloadAsDocumentButton
